var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebarIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 14,
  fill: "none",
  viewBox: "0 0 18 14",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1C",
  fillOpacity: 0.1,
  d: "M5.875.75v12.5h-3.75a.625.625 0 0 1-.625-.625V1.375A.625.625 0 0 1 2.125.75z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.875.125H2.125a1.25 1.25 0 0 0-1.25 1.25v11.25a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V1.375a1.25 1.25 0 0 0-1.25-1.25m-13.75 8.75h1.25a.625.625 0 0 0 0-1.25h-1.25v-1.25h1.25a.625.625 0 0 0 0-1.25h-1.25v-1.25h1.25a.625.625 0 0 0 0-1.25h-1.25v-1.25H5.25v11.25H2.125zm13.75 3.75H6.5V1.375h9.375z"
})));
export { SvgSidebarIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/sidebarIcon.svg";